/*
  goel-variant-bridge.js

  WHY THIS EXISTS
  The store's custom product blocks (price block, add-to-cart block, sticky bar) each cache
  VARIANT_ID / BASE_PRICE in a closure at page load, and each listens for a `variant:change`
  event. This theme is Dawn-derived: it never dispatches `variant:change`. It re-renders the
  product section over the network instead, and inline <script> tags do NOT re-execute when
  markup is replaced via innerHTML.

  Result before this file existed: selecting a different variant updated the visible page but
  not those closures, so Add to Cart posted the FIRST variant's id. Verified on the live store -
  choosing "Red" added "Purple / WK9-PPL OP" to the cart.

  WHAT THIS DOES
  Watches the canonical `variant-selects [data-selected-variant]` JSON that Dawn rewrites on
  every variant change, and dispatches the `variant:change` event the custom blocks already
  expect. It adds no UI and owns no state.
*/
(function () {
  if (window.__goelVariantBridge) return;
  window.__goelVariantBridge = true;

  var lastId = null;

  function currentVariant() {
    var el = document.querySelector('variant-selects [data-selected-variant]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function announce() {
    var v = currentVariant();
    if (!v || v.id === lastId) return;
    lastId = v.id;
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
  }

  // expose so any block can ask for the truth at click time rather than trusting its closure
  window.goelCurrentVariant = currentVariant;

  function start() {
    lastId = (currentVariant() || {}).id || null;

    // Dawn swaps the whole <variant-selects> node, so observe the subtree that contains it.
    var target = document.querySelector('product-info') || document.body;
    var pending = null;
    new MutationObserver(function () {
      clearTimeout(pending);
      pending = setTimeout(announce, 60);
    }).observe(target, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
